import { render, staticRenderFns } from "./contentAliasNames.vue?vue&type=template&id=a89afcce&scoped=true"
import script from "./contentAliasNames.vue?vue&type=script&lang=js"
export * from "./contentAliasNames.vue?vue&type=script&lang=js"
import style0 from "./contentAliasNames.vue?vue&type=style&index=0&id=a89afcce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89afcce",
  null
  
)

export default component.exports